"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MoisesGraphQL = void 0;
const graphql_request_1 = require("graphql-request");
class MoisesGraphQL {
    constructor(config, session) {
        this.config = config;
        this.session = session;
        this.graphQLClient = new graphql_request_1.GraphQLClient(`
    ${this.config.apiEndpoint}${this.config.apiEndpoint.endsWith('/') ? '' : '/'}graphql`);
    }
    async fetch({ variables, query }) {
        return this.graphQLClient.request(query, variables, {
            Authorization: this.session.token,
            ...this.config.headers,
        });
    }
}
exports.MoisesGraphQL = MoisesGraphQL;
